import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const ActionValidIconSmall: React.FC<IconProps> = (props) => (
  <IconWrapper size="small" {...props}>
    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-8 6A6 6 0 1 0 8 2a6 6 0 0 0 0 12Z" />
    <path d="m12.388 5.684-5.865 6.253-3.23-3.23 1.414-1.414 1.77 1.77 4.452-4.747 1.459 1.368Z" />
  </IconWrapper>
)

export default ActionValidIconSmall
